export default "__VITE_ASSET__ttZvqErb__"